import { useCallback, useState } from 'react';

import type { Position } from '../uikit';

export const useDropdownContextMenuTooltipController = () => {
    const [tooltipPosition, setTooltipPosition] = useState<Position>(undefined);
    const [activeTooltip, setActiveTooltip] = useState<{ [key: string]: boolean }>({});
    const [activeTooltipMsg, setActiveTooltipMsg] = useState<string | undefined>(undefined);

    const getMenuItemAttributes = useCallback(
        (item: { haveTooltip: boolean; tooltipName: string; tooltipMsg: string }) => {
            if (item.haveTooltip) {
                return {
                    readOnly: true,
                    name: item.tooltipName,
                    tooltipMsg: item.tooltipMsg,
                };
            }

            return undefined;
        },
        [],
    ) as any;

    const onMenuMouseMove = useCallback((event) => {
        const attr = event.target.getAttributeNames();

        const hasTooltip = attr.includes('readonly');
        const target = event.target.getAttribute('name');
        const targetMsg = event.target.getAttribute('tooltipMsg');

        const rect = event.currentTarget.getBoundingClientRect();
        const targetRect = event.target.getBoundingClientRect();

        const heightItemMenu = 24;

        if (hasTooltip) {
            if (target) {
                setActiveTooltip((prev) => {
                    if (!prev[target]) {
                        return { [target]: true };
                    }

                    return prev;
                });
            }

            setTooltipPosition({ x: rect.right, y: targetRect.bottom - heightItemMenu / 2 });
            setActiveTooltipMsg((prevMsg) => {
                if (targetMsg !== prevMsg) {
                    return targetMsg?.replace(/&nbsp;/g, '\u00A0');
                }

                return prevMsg;
            });
        } else {
            setActiveTooltip({});
            setActiveTooltipMsg(undefined);
        }
    }, []);

    const onMenuMouseLeave = useCallback(() => {
        setActiveTooltip({});
        setActiveTooltipMsg(undefined);
    }, []);

    return {
        getMenuItemAttributes,
        tooltipPosition,
        activeTooltip,
        activeTooltipMsg,
        onMenuMouseMove,
        onMenuMouseLeave,
    };
};
